import React from 'react';
import {InfoIcon} from "./InfoIcon";

export function HelpIcon(props) {
    return <InfoIcon
        className="help-icon"
        glyph={"question-sign"}
        placement="bottom"
        {...props}
    >
        {props.children}
    </InfoIcon>;
}


